require('./provinces-new-container.scss')

module.exports = {
  template: require('./provinces-new-container.pug')()
  controller: require('./provinces-new-container.ctrl')
  bindings:
    country: '<'
    city: '<'
}
